export const DEVICE_TYPE = {
    'RTP':          1,
    'SIP':          2,
    'Multicast':    3,
    'Barionet':     4,
    'Visual':       5,
    'HAVEN':        7,  //HAVEN Lock
    'G2IPSpeaker':  8,
    'G2Link':       9,
}

export const DEVICE_SUBTYPE = {
    'Generic':      1,
    'iOS':          2,
    'Basic':        3,
    'Clock':        4,
    'ClockCamera':  5
}

export const DEVICE_SIP_TYPE = {
    'Generic':      1,
    'Phoenix':      2,
    'HUB':          3,
    'MS450':        4,
    'MS250':        5,
    'External':     6,
    'Advanced':     7,  // Advanced Network Device
    'HUB2':         8,  // HUB 2
}

export const ZONE_TYPE = {
    'Devices':      1,
    'Zones':        2,
    'Multicast':    3,
    'Visual':       4,
}